import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import TheJob from '../sections/theJob';
import Qualification from '../sections/qualification';
import Budget from '../sections/budget';
import AboutCompany from '../sections/aboutCompany';
import CompanyPerks from '../sections/companyPerks';
import { updateJob, getPoolSize } from 'controllers/job';
import { setFlag } from 'controllers/flags';

const Create = (props) => {
  const [jobLocationLocal, setJobLocationLocal] = useState('');
  const [skillSearch, setSkillSearch] = useState('');
  //const [poolSize, setPoolSize] = useState('');
  const selectedJob = useSelector((state) => state.job.selectedJob);
  const organizationId = useSelector(
    (state) => state.user.details.organizationInfo.organizationId
  );

  const { gridWidth = 6, displayType, errorFlag } = props;

  const {
    company,
    educationRequired,
    minExperience,
    maxExperience,
    positionCount,
    jobLocation,
    currency,
    minSalary,
    maxSalary,
    salaryTime,
    currencyValue,
    skills,
    jobRole,
    employmentType,
    jobDescription,
    lookForSchools,
    domains,
    location,
    foundedYear,
    companySize,
    aboutCompany,
    perks,
  } = selectedJob;

  useEffect(() => {
    setFlag('error', false);
  }, []);

  useEffect(() => {
    const apiBody = {
      experienceEnd: maxExperience || 0,
      experienceStart: minExperience || 0,
      jobTitle: jobRole,
      locations: jobLocation,
      organizationId,
      skills,
    };
    getPoolSize(apiBody);
  }, [
    jobRole,
    skills,
    minExperience,
    maxExperience,
    jobLocation,
    organizationId,
  ]);

  const onChange = (e) => {
    if (e.target.name === 'jobLocationLocal') {
      setJobLocationLocal(e.target.value);
    }

    if (e.target.name === 'skillSearch') {
      setSkillSearch(e.target.value);
    }
  };

  const onUpdateJobHandler = (e) => {
    if (e.target.name) {
      if (
        (e.target.name === 'minSalary' || e.target.name === 'maxSalary') &&
        e.target.value
      ) {
        updateJob({
          [e.target.name]: parseInt(e.target.value) || 0,
        });
        return true;
      }

      updateJob({
        [e.target.name]: e.target.value,
      });
    }
  };

  const onChangeHandlerEducation = (e) => {
    const value = e.target.value;
    if (educationRequired.find((education) => education === value)) {
      updateJob({
        educationRequired: educationRequired.filter(
          (education) => education !== value
        ),
      });
    } else {
      updateJob({
        educationRequired: [...educationRequired, value],
      });
    }
  };

  const onChangeHandlerDescription = (value) => {
    updateJob({
      jobDescription: value,
    });
  };

  const onUpdateOrganization = (key, value) => {
    updateJob({
      [key]: value,
    });
  };

  const onSelectJobRole = (e, value) => {
    updateJob({
      jobRole: value.suggestion,
    });
  };

  const onChangePositionCount = (e, positionCount) => {
    updateJob({
      positionCount,
    });
  };

  const onChangeExperience = (e, value) => {
    const [minExperience, maxExperience] = value;

    updateJob({
      minExperience,
      maxExperience,
    });
  };

  const onSelectLocation = (e, value) => {
    const updatedJobLocation = new Set([...jobLocation, value.suggestion]);

    updateJob({
      jobLocation: [...updatedJobLocation],
    });
    setJobLocationLocal('');
  };

  const onDeleteLocation = (value) => {
    const filteredArray = jobLocation.filter((location) => location !== value);

    updateJob({
      jobLocation: filteredArray,
    });
  };

  const onSelectSkill = (value) => {
    const updatedSkills = new Set([...skills, value]);

    updateJob({
      skills: [...updatedSkills],
    });

    setSkillSearch('');
  };

  const onDeleteSkill = (value) => {
    const filteredArray = skills.filter((skill) => skill !== value);

    updateJob({
      skills: filteredArray,
    });
  };

  return (
    <Grid item xs={gridWidth}>
      <TheJob
        errorFlag={errorFlag}
        jobRole={jobRole}
        company={company}
        employmentType={employmentType}
        jobLocationLocal={jobLocationLocal}
        positionCount={positionCount}
        locationArray={jobLocation}
        jobDescription={jobDescription}
        onDeleteLocation={onDeleteLocation}
        onSelectLocation={onSelectLocation}
        onChangePositionCount={onChangePositionCount}
        onSelectJobRole={onSelectJobRole}
        onChangeHandlerDescription={onChangeHandlerDescription}
        onChange={onChange}
        onUpdateJobHandler={onUpdateJobHandler}
        onUpdateOrganization={onUpdateOrganization}
        displayType={displayType}
      />
      <Qualification
        errorFlag={errorFlag}
        onDeleteSkill={onDeleteSkill}
        onSelectSkill={onSelectSkill}
        skills={skills}
        skillSearch={skillSearch}
        educationRequired={educationRequired}
        onChangeHandlerEducation={onChangeHandlerEducation}
        onChange={onChange}
        onChangeExperience={onChangeExperience}
        minExperience={minExperience}
        maxExperience={maxExperience}
        displayType={displayType}
        domains={domains}
        lookForSchools={lookForSchools}
      />
      <Budget
        errorFlag={errorFlag}
        currency={currency}
        minSalary={minSalary}
        maxSalary={maxSalary}
        currencyValue={currencyValue}
        salaryTime={salaryTime}
        onChange={onUpdateJobHandler}
      />
      <AboutCompany
        onUpdateOrganization={onUpdateOrganization}
        location={location || ''}
        foundedYear={foundedYear || ''}
        companySize={companySize || ''}
        aboutCompany={aboutCompany || ''}
        errorFlag={errorFlag}
      />
      <CompanyPerks
        perks={perks}
        onUpdateOrganization={onUpdateOrganization}
        displayType={displayType}
      />
    </Grid>
  );
};

export default Create;
